import React, { useState, useEffect } from 'react';
import { getAlldata } from '../controllers/APIController';

const TaskCounter = () => {
  const [taskCount, setTaskCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const countTasks = async () => {
      try {
        setLoading(true);
        
        const response = await getAlldata("tasks");
        
        // Handle different response structures
        let tasks = [];
        if (response && Array.isArray(response)) {
          // Direct array response
          tasks = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // Nested data response
          tasks = response.data;
        } else if (response && response.data && Array.isArray(response.data.data)) {
          // Double nested data response
          tasks = response.data.data;
        } else {
          console.error("Unknown response structure:", response);
        }
        
        // Validate that we have an array of tasks
        if (!Array.isArray(tasks)) {
          console.error("tasks is not an array:", tasks);
          tasks = [];
        }
        
        const count = tasks.length;
        setTaskCount(count);
      } catch (error) {
        console.error("Error counting tasks:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    countTasks();
  }, []);

  if (loading) {
    return (
      <div className="p-4 bg-emerald-50 rounded-lg border border-emerald-200">
        <div className="text-emerald-700 font-medium">Loading task count...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 rounded-lg border border-red-200">
        <div className="text-red-700 font-medium">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-emerald-50 rounded-lg border border-emerald-200 shadow-sm">
      <h3 className="text-lg font-semibold text-emerald-800 mb-2">
        Task Collection Status
      </h3>
      <div className="text-3xl font-bold text-emerald-600">
        {taskCount}
      </div>
      <div className="text-sm text-emerald-700 mt-1">
        {taskCount === 1 ? 'task' : 'tasks'} in collection
      </div>
    </div>
  );
};

export default TaskCounter;
